import { DIALOG_DATA } from '@angular/cdk/dialog';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { SHARED_MODULES } from '@app/shared';

@Component({
  selector: 'app-modal-games',
  imports: [SHARED_MODULES],
  templateUrl: './modal-games.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ModalGamesComponent {
  public data: { gamePath: string; gameTitle: string } = inject(DIALOG_DATA);
  public gameTitle: string;
  public gamePath: string;
  constructor() {
    this.gameTitle = this.data.gameTitle;
    this.gamePath = this.data.gamePath;
  }
}
